import { planLabel } from './planLabels';

/**
 * 产品推荐默认配额（与 docs/配额与会员方案.md 一致）。
 * Admin「会员配额」页只读展示；实际运行以 DB quota_plan 为准。
 */
export const RECOMMENDED_QUOTA_PLANS = [
  {
    planCode: 'FREE',
    maxFileMb: 1536,
    maxDurationMin: 60,
    slicesPerDay: 3,
    slicesPerMonth: 30,
    maxRunningTasks: 1,
    priorityQueue: false,
    note: '测试期临时；正式收费后恢复 1GB/45min；BETA_FREE 读此行',
  },
  {
    planCode: 'PRO',
    maxFileMb: 1536,
    maxDurationMin: 120,
    slicesPerDay: 20,
    slicesPerMonth: 360,
    maxRunningTasks: 2,
    priorityQueue: true,
    note: '单文件 ≤ 线上硬顶 1.5GB',
  },
  {
    planCode: 'PRO_PLUS',
    maxFileMb: 2048,
    maxDurationMin: 180,
    slicesPerDay: 40,
    slicesPerMonth: 800,
    maxRunningTasks: 3,
    priorityQueue: true,
    note: '单文件 2GB；线上环境硬顶须 ≥ 2048',
  },
  {
    planCode: 'TEAM',
    maxFileMb: 20480,
    maxDurationMin: 240,
    slicesPerDay: 60,
    slicesPerMonth: 1200,
    maxRunningTasks: 3,
    priorityQueue: true,
    note: '单文件 20GB；环境硬顶须 ≥ 20480',
  },
];

export function recommendedPlanLabel(planCode) {
  return planLabel(planCode);
}
